import home from './home'
import comment from './comment'
import address from './address'
import confirm from './confirm'
import order from './order'
import user from './user'
import orderList from './order_list'
import entering from './entering'
import worker from './worker'
import store from './store'
import category from './category'
import collect from './collect'
import im from './im'
import product from './product'
import spu from './spu'
import coupon from './coupon'
import activityShare from './activity_share'
import business from './business'
import log from './log'
import secKill from './secKill'
import groupBuy from './groupBuy'
import serviceLog from './serviceLog'
import recovery from './recovery'
import newComent from './newComent' // 育儿最新评论

export default {
  ...home,
  ...comment,
  ...address,
  ...confirm,
  ...order,
  ...user,
  ...orderList,
  ...entering,
  ...worker,
  ...store,
  ...collect,
  ...category,
  ...im,
  ...product,
  ...spu,
  ...coupon,
  ...activityShare,
  ...business,
  ...log,
  ...secKill,
  ...groupBuy,
  ...serviceLog,
  ...recovery,
  ...newComent
}
